export default __webpack_public_path__ + "static/media/soesvinget-property-13.4ede053e.jpg";